module.exports = __webpack_public_path__ + "static/media/docker.89764a26.jpg";